import React from "react";
import { handleSchedulerTypes } from "../../../shared/utils/handleSchedulerTypes";
import { handleDramaturgyTypeByFormat } from "../../../shared/utils/handleDramaturgyTypeByFormat";
import AttachmentsScheduler from "../../AttachmentsScheduler/AttachmentsScheduler";

export default function SchedulerView({
  contentId,
  projectType,
  isExternal,
  stateCurrentTab,
  schedulerType,
  contentFormat,
  reload,
  sharingPermissions,
}) {
  const isDramaturgyLong =
    projectType === "Dramaturgia" &&
    handleDramaturgyTypeByFormat(contentFormat) === "Dramaturgia Longa";

  const isDramaturgyShort =
    projectType === "Dramaturgia" &&
    handleDramaturgyTypeByFormat(contentFormat) === "Dramaturgia Curta";

  const isVarieties = projectType === "Variedades";

  const currentTabIsAttachments = stateCurrentTab === "attachments";

  if (isExternal) return <></>;

  return (
    <>
      {(isDramaturgyLong || isDramaturgyShort) && currentTabIsAttachments && (
        <div
          className={`${
            schedulerType === "Capítulos"
              ? "mainContainer"
              : "mainContainerExtended"
          } `}
        >
          <AttachmentsScheduler
            contentId={contentId}
            schedulerType={schedulerType}
            downloadContext="materiais"
            contentType={projectType}
            reload={reload}
            sharingPermissions={sharingPermissions}
          />
        </div>
      )}
      {isVarieties && currentTabIsAttachments && (
        <div className={"mainContainerExtended"}>
          <AttachmentsScheduler
            contentId={contentId}
            schedulerType={handleSchedulerTypes(projectType)}
            downloadContext="materiais"
            contentType={projectType}
            reload={reload}
            sharingPermissions={sharingPermissions}
          />
        </div>
      )}
    </>
  );
}
